(function () {
  const money = (cents) => {
    const value = (Number(cents) / 100).toLocaleString("en-PK", {
      maximumFractionDigits: 0
    });
    return "Rs. " + value;
  };

  const pad = (n) => String(n).padStart(2, "0");

  const tickCountdowns = () => {
    document.querySelectorAll("[data-nexus-countdown]").forEach((root) => {
      const now = Date.now();
      const day = new Intl.DateTimeFormat("en-CA", {
        timeZone: "Asia/Karachi",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date());
      const end = Date.parse(`${day}T23:59:59+05:00`);
      let diff = Math.max(0, end - now);
      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;
      const seconds = Math.floor(diff / 1000);
      const h = root.querySelector("[data-cd-h]");
      const m = root.querySelector("[data-cd-m]");
      const s = root.querySelector("[data-cd-s]");
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    });
  };
  tickCountdowns();
  setInterval(tickCountdowns, 1000);

  document.querySelectorAll("[data-nexus-upsell]").forEach((root) => {
    const form = root.querySelector("[data-upsell-form]");
    const totalEl = root.querySelector("[data-upsell-total]");
    if (!form || !totalEl) return;

    const current = form.querySelector('input[name="current"]');
    const extras = () => [...form.querySelectorAll('input[name="upsell"]')];

    const updateTotal = () => {
      let total = Number(current?.dataset.price || 0);
      extras().forEach((box) => {
        if (box.checked) total += Number(box.dataset.price || 0);
      });
      totalEl.textContent = money(total);
    };

    extras().forEach((box) => box.addEventListener("change", updateTotal));
    updateTotal();

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const items = [{ id: Number(current.value), quantity: 1 }];
      extras().forEach((box) => {
        if (box.checked) items.push({ id: Number(box.value), quantity: 1 });
      });
      const button = form.querySelector("button[type='submit']");
      button.disabled = true;
      button.textContent = "Adding...";
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
        window.location.href = "/cart";
      } catch (error) {
        button.disabled = false;
        button.textContent = "Add selected to cart";
      }
    });
  });

  const addMoreBoxes = () => [...document.querySelectorAll('[data-nexus-addmore] input[name="addmore"]')];
  const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm && addMoreBoxes().length) {
    productForm.addEventListener("submit", async (event) => {
      const extras = addMoreBoxes().filter((box) => box.checked);
      if (!extras.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const idInput = productForm.querySelector('input[name="id"]');
      const qtyInput = productForm.querySelector('input[name="quantity"]');
      const items = [
        { id: Number(idInput?.value), quantity: Number(qtyInput?.value || 1) },
        ...extras.map((box) => ({ id: Number(box.value), quantity: 1 })),
      ];
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
        window.location.href = "/cart";
      } catch (error) {
        productForm.submit();
      }
    }, true);
  }

  const sticky = document.querySelector("[data-nexus-sticky]");
  const atc = document.querySelector("#product-add-to-cart, [data-btn-addToCart]");
  if (sticky && atc) {
    const toggle = () => {
      const rect = atc.getBoundingClientRect();
      sticky.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
    };
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    sticky.querySelector("[data-nexus-sticky-atc]")?.addEventListener("click", () => {
      atc.click();
    });
  }
})();
